import { useCallback, useMemo } from 'react';

import {
  useRfqBuilderActions,
  useRfqBuilderView,
} from '@paradigm/features/src/unified-rfqs/ui';

import Toggle from '@paradigm/design-system/src/components/Toggle';
import { useTrackAction } from '@paradigm/features/src/analytics';

export default function AnonymousSwitch() {
  const { anonymous, isOrderBook } = useRfqBuilderView();
  const { toggleAnonymous } = useRfqBuilderActions();
  const trackAction = useTrackAction();
  const labelText = 'Anonymous';

  const handleOnChange = useCallback(() => {
    trackAction('toggle anonymity');
    toggleAnonymous();
  }, [toggleAnonymous, trackAction]);

  return useMemo(
    () =>
      isOrderBook ? (
        <div css="visibility: hidden;" />
      ) : (
        <Toggle
          ariaLabel={labelText}
          label={labelText}
          checked={anonymous}
          onChange={handleOnChange}
        />
      ),
    [anonymous, handleOnChange, isOrderBook],
  );
}
